import { Pipe, PipeTransform } from '@angular/core';
import { JobMediaItem } from '@jms/model';

@Pipe({
  name: 'mediaType',
  standalone: true
})
export class MediaTypePipe implements PipeTransform {

  transform(media: JobMediaItem): string {
    if (media?.type !== 'Image')
      return media.type;

    // hack to get signature type
    const splitMediaId = media._id.split('::');

    if (splitMediaId?.length === 1)
      return media.type;

    return 'Signature';
  }

}
